import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TopBar, Container } from 'splash/components';

const styles = (theme) => ({
  content: {
    flex: '1 1 auto',
    padding: theme.spacing(1),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  icon: {
    margin: `${theme.spacing(0)}px auto ${theme.spacing(3)}px auto`,
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
  },
  svg: {
    width: 'inherit',
    height: 'inherit',
  },
});

const Loading = ({ intl: { messages }, classes }) => (
  <Container>
    <TopBar title={messages.catalogues_loading} />
    <div className={classes.content}>
      <div className={classes.icon}>
        <CircularProgress color="secondary" className={classes.svg} />
      </div>
    </div>
  </Container>
);

Loading.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.shape({
      catalogues_loading: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const WithStylesLoading = withStyles(styles)(Loading);

export default injectIntl(WithStylesLoading);
